import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly translate = inject(TranslateService);
  private readonly storage = inject(StorageService);

  private readonly supportedLanguages = ['it', 'en'];

  constructor() {
    this.translate.addLangs(this.supportedLanguages);
    this.translate.setFallbackLang('en');

    const savedLanguage = this.storage.getLanguage();
    const language = this.supportedLanguages.includes(savedLanguage) ? savedLanguage : 'it';
    this.translate.use(language);
  }

  setLanguage(language: string): void {
    if (this.translate.getLangs().includes(language)) {
      this.translate.use(language);
      this.storage.setLanguage(language);
    }
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang ?? this.storage.getLanguage();
  }
}
